module.exports = __webpack_public_path__ + "img/belucalogo.a182fad5.svg";